import { createApp } from 'vue'
import App from './App.vue'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import vuetify from './plugins/vuetify'
import { MotionPlugin } from '@vueuse/motion'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(MotionPlugin)
  .mount('#app')

